import utility from "./utility";
import cache from "./cache_ls";
import message_format from "../components/message_format";
import request from "./curl";
import InfiniteLoading from 'vue-infinite-loading';
import media_utility from "./media_utility";
import compChatmsgMenuActions from "../components/chatmsg_menu_actions";
import content_forward_dialog  from "../components/content_forward_dialog";
import report_issue_dialog  from "../components/report_issue_dialog";
import { longClickDirective } from 'vue-long-click'
const longClickInstance = longClickDirective({delay: 300, interval: 0})

export default {
  name: 'pinned_message_list',
  components:{
    message_format,
    InfiniteLoading,
    content_forward_dialog,
    report_issue_dialog,
    compChatmsgMenuActions,
  },
  data () {
    return {
      loading: true,
      title:'pinned_message',
      data:[],
      data_add_msg:{},
      styleObject:{
        background: '#FAFAFA',
        position: 'fixed',
        bottom: '0px',
        padding: '10px!important',
        width:'100%',
        display: 'block',
      },
      err_msg: '',
      snackbar: false,
      per_page:process.env.VUE_APP_APP_MESSAGE_PER_PAGE,
      page:false,
      pagination_message_id:null,
      first_time_loader:false,
      user_contact_list_lf:{},
      participant_is_admin: false,
      delete_chatmsg_dialog:false,
      forwardDialogShow:false,
      content_forward_data: {},      
      reportIssueDialogShow:false,
      report_issue_data: {},
      showChatMsgActionMenu: false,
      selectedChatMsgForAction: '',
    }
  },
  async updated() {
    //Get message mysql id for pagination to load older message after scrolling and adding message
    let pinnedMessageList = this.getPinnedMessage;
    if(pinnedMessageList && pinnedMessageList.length > 0){ 
      let max_id_arr = [];
      for(let index in pinnedMessageList){
        max_id_arr.push(pinnedMessageList[index].id)
      }

      this.pagination_message_id = await Math.max(...max_id_arr);
    }
  },
  created() {
  },
  async mounted() {
    this.user_contact_list_lf = await this.getUserContactList;
    await this.get_group_details();
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    async selectedGroup() {
      return await this.$store.getters.selectedGroup;
    },
    getPinnedMessage(){
      let pinnedMessageList = this.$store.getters.getPinnedMessage;
     return (pinnedMessageList) ? pinnedMessageList : [];
    },
    async getUserContactList(){
      return await this.$store.getters.getUserContactList;
    },
    async getChatgrpList(){
      return await this.$store.getters.getChatgrpList;
    },
  },
  methods: {
   /**
     * get_group_details
     * Get from LS, else via API
     * TODO: This function can be optimised. No need for the loop use the group_id as the object key to get/set data
     */
    async get_group_details() {
      let grp_details = await this.getChatgrpList;
      let selectedGroupId = await this.selectedGroup;
      if(grp_details) {
        for(let index in grp_details) {          
          if(grp_details[index]){
            //Get data for the currently selected Group
            if(grp_details[index]['group_id'] && (grp_details[index]['group_id'] === selectedGroupId)) {
              let grp = grp_details[index];
              this.participant_is_admin = (grp.role == 1) ? true : false;
              break;
            }
          }
        }
      }
      else{
        this.$router.push('/warnings');
      }
    },    
   /**
    * msg_time
    */
    msg_time(timestamp) {
        return utility.get_message_datetime(timestamp, 'DD/MM/YYYY');
    },
    /**
     * scroll_to_pinnedmsg
     */
    scroll_to_pinnedmsg(msg_id) {
      this.$store.commit('setScrollToPinnedmsg', msg_id);
      this.$router.push('/chat_message');
    },
    /**
     * sortPinnedMessage
     */
    sortPinnedMessage(pinned_message){
      return pinned_message.sort(function(a, b){
        if(a && b && a.id && b.id){
          let x = b.id;
          let y = a.id;
          if (x < y) {return -1;}
          if (x > y) {return 1;}
          return 0;
        }

        return 0;
      });
    },
    /**
     * get_pinned_message
     */    
    async get_pinned_message($state){ 
      let pinnedMessageList = this.getPinnedMessage;
      if(pinnedMessageList.length <= 0 ){
        this.first_time_loader = true;
      }
      
      let selectedGroupId = await this.selectedGroup;
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("group_id", selectedGroupId);
      post_data.append("pagination_type", 'page_index');
      
      // if(this.pagination_message_id){
      //   post_data.append('message_id', this.pagination_message_id);
      // }
      
      post_data.append("message_type", '11');
      post_data.append("per_page", this.per_page);

      request.curl(this, "message_list", post_data)
      .then(async response => {
        this.loading = false;
        if(response.resp_status) {
          await this.data.unshift(...response.resp_data.data.reverse());
          this.$store.commit('setPinnedMessage', this.data);
          $state.loaded();
          if(this.data.length == response.resp_data.total_count){
            $state.complete();
          }
        }
        else{
          $state.complete();
        }
      });
    },
    /**
     * chatmsg_actions_menu_show
     */
    chatmsg_actions_menu_show(msg) {
      if(this.scrollStart == true){
        return;
      }

      if(this.selectedTag){ 
        if(this.selectedTag.type == 4){
          //For Mention
          this.showChatMsgActionMenu = false;
          return;
        }
      }
      
      this.do_not_scroll = true;
      this.selectedChatMsgForAction = msg;
      this.text_to_copy = msg.text_msg;

      if(this.selectedChatMsgForAction.is_reply == 1){
        this.show_scroll_to_reply = true;
        this.to_scroll_reply_msg = this.selectedChatMsgForAction.message_id;
      }
      else{
        this.show_scroll_to_reply = false;
        this.to_scroll_reply_msg = '';
      }

      if(this.selectedChatMsgForAction.message_type == undefined){
        this.selectedChatMsgForAction.message_type = '10';
      }
      
      this.selectedChatMsgForAction.userData = this.userData;
      this.selectedChatMsgForAction.participant_is_admin = this.participant_is_admin;

      //Set the Menu Show/Hide Options
      this.selectedChatMsgForAction.showChatMsgActionMenu = true;
      this.selectedChatMsgForAction.showDoReply = false;      
      this.selectedChatMsgForAction.showDeleteMessage = true;
      this.selectedChatMsgForAction.showPinnedMessage = true;
      this.selectedChatMsgForAction.showUnPinnedMessage = true;
      this.selectedChatMsgForAction.showGotoMessage = false;
      this.selectedChatMsgForAction.showForwardMessage = true;
      this.selectedChatMsgForAction.showCopyMessage = true;
      this.selectedChatMsgForAction.showReportIssue = true;

      this.showChatMsgActionMenu = true;
      //this.reply_msg = {};
    },     
    /**
     * updateShowMsgActionsState
     * update the showChatMsgActionMenu value after action menu closes
     */    
    async updateShowMsgActionsState(showChatMsgActionMenu){
      this.showChatMsgActionMenu = showChatMsgActionMenu;
    },  
    /**
     * share_send_dialog_open
     */
    async share_send_dialog_open(){
      this.showChatMsgActionMenu = false;
      this.content_forward_data.text_msg = this.text_to_copy;
      this.content_forward_data.module = 'message';
      this.content_forward_data= this.content_forward_data;
      
      //media message forward
      if(this.selectedChatMsgForAction.message_content_type == 1){ // 1 is media message
        this.content_forward_data.message_content_type = this.selectedChatMsgForAction.message_content_type;
        this.content_forward_data.message_content_id = this.selectedChatMsgForAction.message_content_data.id;
      }
      else{
        this.content_forward_data.message_content_type = null
        this.content_forward_data.message_content_id = null;
      }
      
      this.forwardDialogShow = true;
    },
    /*
    * report_issue_dialog_open
    * 
    */
    report_issue_dialog_open(){
      let msg = this.selectedChatMsgForAction;
      this.report_issue_data.module_obj_id = msg.this_message_id;
      this.report_issue_data.content_text = msg.text_msg;
      this.report_issue_data.module_type = 'message';
      this.reportIssueDialogShow = true;
      this.showChatMsgActionMenu = false;
    },     
    /**
     * pin_msg called from vue
     * Used for PIN/UNPIN
     */
    async pin_msg(new_message_type) {
      let selectedGroupId = await this.selectedGroup;
      let msg_id = this.selectedChatMsgForAction.this_message_id;
      
      let index = this.data.findIndex(x => x && x.this_message_id && x.this_message_id === msg_id);
      this.$set(this.data[index],'message_type', new_message_type);

      this.do_not_scroll = true;
      this.showChatMsgActionMenu = false;
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("group_id", selectedGroupId);
      post_data.append("this_message_id", msg_id);
      post_data.append("message_type", new_message_type);

      request.curl(this, "message_pin", post_data)
      .then(async response => {
        if(response.resp_status) {
          this.data = this.data.filter((x) => x.this_message_id != msg_id);
          this.$store.commit('setPinnedMessage', this.data);           

          //Update in Chatmsg List as well
          let chatmsg_list = await cache.get_chatmsg_list_lf(selectedGroupId);
          let index = chatmsg_list.findIndex(x => x && x.this_message_id && x.this_message_id === msg_id);

          if(chatmsg_list[index]){
            chatmsg_list[index].message_type = new_message_type;
            await cache.set_chatmsg_list_lf(selectedGroupId, chatmsg_list);
          }
        }
      });
    }, 
    /**
     * doCopy
     * Copy msg from "copy-msg-input" text field
     */
    doCopy: function () {
      var copyText = document.getElementById("copy-msg-input");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      this.showChatMsgActionMenu = false;
      
      this.snackbar = true;
      this.err_msg = 'Copied';
    },
    /**
     * open_delete_chatmsg_dialog
     *
     */  
    open_delete_chatmsg_dialog(){
      this.delete_chatmsg_dialog = true;
    },
    /**
     * delete_message
     *
     */
    delete_message:async function(){
      let this_message_id = this.selectedChatMsgForAction.this_message_id;
      let message_index = this.data.findIndex((msg) => msg.this_message_id === this_message_id);
      this.$delete(this.data, message_index);

      this.snackbar = true;
      this.err_msg = 'Message deleted';
      //async message delete
      var post_data = new FormData();
      post_data.append("chat_user_id", this.userData.user_id);
      post_data.append("group_id", await this.selectedGroup);
      post_data.append("this_message_id", this_message_id);

      request.curl(this, "message_delete", post_data)
        .then(response => {
          if(response.resp_status) {
            console.log(response);
          }
        });
      this.delete_chatmsg_dialog = false;
      this.showChatMsgActionMenu = false;
    },          
    /*
    * checkStrFirstCharHasAlphabet
    * */
    checkStrFirstCharHasAlphabet(str){
      if(/^[A-Za-z]/.test(str)) {
        return true;
      }
      return false;
    },
    /*
    * get_user_icon
    * */
    get_user_icon(msg){
      var user = {
        user_id : msg.sender_id,
        image : msg.sender_image,
        user_name: msg.sender_name
      }
      var user_icon = media_utility.get_user_icon(user, this.user_contact_list_lf);
      return user_icon;
    }
  },
  watch: {
  },
  directives:{
    'longclick': longClickInstance,
  }
}
